import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getUserSelector } from "store/auth/selector";
import { AuthState as AuthType } from "store/auth/types";
import { AuthState } from "store/rootReducer";
import { SPLA_ROLE_ID } from "utils/constants/constant";
import { AppPages } from "utils/enums/app-pages";
import { getPagePermissions, hasRequiredRole } from "utils/helper";
import { ISLPDashboardContainerDispatch } from "utils/interfaces/slp";
import SLPRequests from "./SLPRequests";
import CompletedSLPs from "./CompletedSLP";

export type SLPDashboardProps = ISLPDashboardContainerDispatch;

const SLPDashboard: React.FC<SLPDashboardProps> = (props) => {
  const user = useSelector<AuthState, AuthType["user"]>(getUserSelector);
  const history = useHistory();

  const isSPLAUser = useMemo(
    () => hasRequiredRole(user?.roleID ?? [], SPLA_ROLE_ID),
    [user]
  );

  const {
    slpRequestsPDFRequest,
    slpRequestsRequest,
    plaUserListRequest,
    // updateSLPContactProgressRequest,
    completedSLPListRequest,
    completedSLPListPDFRequest,
    updateSLPParticipationRequest,
    updateSLPContactNoteRequest,
    allocatePLARequest,
    updateContactDateRequest,
    deferSLPRequest,
  } = props;

  useEffect(() => {
    const isViewAllowed = getPagePermissions(
      user?.permissions,
      AppPages.SLPDashboard,
      "student learning plan"
    )?.view;

    if (!isViewAllowed) {
      history.goBack();
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  return (
    <div>
      <Box className="content-header">
        <Typography variant="h2" className="heading">
          SLP Dashboard
        </Typography>
      </Box>
      <Grid
        container
        spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
        className="content-container"
      >
        <SLPRequests
          slpRequestsPDFRequest={slpRequestsPDFRequest}
          slpRequestsRequest={slpRequestsRequest}
          plaUserListRequest={plaUserListRequest}
          // updateSLPContactProgressRequest={updateSLPContactProgressRequest}
          updateSLPParticipationRequest={updateSLPParticipationRequest}
          updateSLPContactNoteRequest={updateSLPContactNoteRequest}
          updateContactDateRequest={updateContactDateRequest}
          isSPLAUser={isSPLAUser}
          allocatePLARequest={allocatePLARequest}
          userId={user.id}
          deferSLPRequest={deferSLPRequest}
        />
        <CompletedSLPs
          completedSLPListPDFRequest={completedSLPListPDFRequest}
          completedSLPListRequest={completedSLPListRequest}
          plaUserListRequest={plaUserListRequest}
          userId={user.id}
        />
      </Grid>
    </div>
  );
};
export default SLPDashboard;
